import type { CategoriesApi } from "@/v2/api/metadata/categories";
import { createFeedConfigDialogApi } from "@/v2/kits/feed-config";
import { categoryId } from "../../shared";

export function createCategoryFeedConfigApi(categories: CategoriesApi) {
  return createFeedConfigDialogApi(({ values }) => categoryId(values), {
    getFeedTypeMappings: categories.getFeedTypeMappings.bind(categories),
    getFeedInstanceMappings: categories.getFeedInstanceMappings.bind(categories),
    updateEntity: async (entityId, payload) => {
      await categories.update(entityId, payload);
    },
  });
}
